/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* layouts-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Actualizar layout"
    modal-title="Editar layout"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave"
  >
    <div class="content">
      <layouts-form
        ref="form"
        :old="oldLayout"
      />
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import LayoutsForm from '@/modules/layouts/layouts-form'
import LayoutsGuards from '@/guards/layouts.guards'
import {mapGetters} from 'vuex'

export default {
  name: 'LayoutsCreateView',
  components: {FormModal, LayoutsForm},
  computed: {
    ...mapGetters('layouts', {
      oldLayout: 'item'
    })
  },
  methods: {
    onCloseModal () {
      this.$router.push({name: 'layouts'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  beforeRouteEnter: LayoutsGuards.onEdit
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
  .content {
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/layouts/layouts-edit-view.vue